<div class="associated-company-card-container container default-padding mat-elevation-z1" fxLayout="column"
     fxLayoutGap="15px">
  <div *ngIf="company; else noCompany" fxLayout="column" fxLayoutGap="15px">
    <div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ company.name }}</h2>
        <div fxFlex></div>
        <a [href]="'/administration/company/' + company.uuid" target="_blank">
          <fa-icon class="color-help clickable" icon="link" [matTooltip]="'associatedCompany.viewDetails' | translate"></fa-icon>
        </a>
      </div>
      <hr/>
    </div>

    <span>
      {{ userProfile.getDisplayName() }}
      {{ 'associatedCompany.is' | translate }}
      {{ userProfile.isCompanyAdministrator ? ('associatedCompany.admin' | translate) : ('associatedCompany.member' | translate) }}
      {{ 'associatedCompany.ofThisCompany' | translate }}.
    </span>

    <div fxLayout="column">
      <mtn-key-value [key]="'associatedCompany.type' | translate">
        <span>{{ company.license.type }}</span>
      </mtn-key-value>

      <mtn-key-value [key]="'associatedCompany.expirationDate' | translate">
        <span *ngIf="company.license.expirationDate; else nonExpiring">
          {{ company.license.expirationDate | insightsDate }}
        </span>
        <ng-template #nonExpiring>
          <span class="color-muted">{{ 'associatedCompany.nonExpiring' | translate }}</span>
        </ng-template>
      </mtn-key-value>

      <mtn-key-value [key]="'associatedCompany.status' | translate">
        <span class="color-success" *ngIf="company.license.isValid()">{{ 'associatedCompany.active' | translate }}</span>
        <span class="color-error" *ngIf="company.license.isExpired()">{{ 'associatedCompany.expired' | translate }}</span>
      </mtn-key-value>
    </div>
  </div>

  <ng-template #noCompany>
    <div class="no-company-container container" fxLayout="column" fxLayoutAlign="center center"
         *ngIf="!userProfile?.company?.uuid">
      <span class="color-muted">{{ 'associatedCompany.noCompany' | translate }}</span>
    </div>
  </ng-template>

  <mtn-spinner [on]="!company" *ngIf="userProfile?.company?.uuid"></mtn-spinner>
</div>
